export enum ViewMode {
  Cards = "cards",
  Table = "table"
}
